import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Company} from "../../models/company";
import {Service} from "../../models/service";
import {NgxSmartModalService} from "ngx-smart-modal";
import {UserService} from "../../services/user/user.service";
import {CategoryService} from "../../services/category/category.service";
import {ServiceService} from "../../services/service/service.service";
import {CompanyService} from "../../services/company/company.service";
import {ActivatedRoute, Router} from "@angular/router";
import Swal from "sweetalert2";
import {Constants} from 'src/app/constants';
import {TRANSACTION_TARIFF_TIERS} from '../../constants/transaction-tariff-tiers';
import {
    CompanyContactsOnboardingData,
    CompanyInfoOnboardingData,
    CompanyRepresentativeOnboardingData,
    CompanyServicesOnboardingData,
    CompanyTermsOnboardingData,
    OnboardingApiResult,
    OnboardingService,
    getOnboardingErrorCopy
} from '../../services/onboarding/onboarding.service';
import {RegisterCompanyDocumentField} from './steps/legal-data/legal-data-step.component';

@Component({
    selector: 'app-register-company',
    templateUrl: './register-company.component.html',
    styleUrls: ['./register-company.component.scss']
})
export class RegisterCompanyComponent implements OnDestroy {

    @Input() idService: string | null = null;
    @Output('step') public stepEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output('listOfSteps') public listOfStepsEmitter: EventEmitter<any> = new EventEmitter<any>();

    stepsCompany: any[] = [
        {id: 1, title: 'Account manager', text: ""},
        {id: 2, title: 'Dati rappresentante', text: ""},
        {id: 3, title: 'Contatti rappresentante', text: ""},
        {id: 4, title: 'Informazioni societarie', text: ""},
        {id: 5, title: 'Seleziona servizi', text: ""},
        {id: 6, title: 'Termini e condizioni', text: ""},
        {id: 7, title: 'Verifica OTP/Token', text: ""},
        {id: 8, title: 'Metodo di pagamento', text: ""},
        {id: 9, title: 'Congratulazioni', text: ""},
    ];

    stepNumber: number = 0;
    steps: any[] = [];

    newCompany: Company = new Company();

    services: Service[] = [];

    servicesSelected: Service[] = [];

    billingPeriod: 'monthly' | 'yearly' = 'monthly';

    tariffTiers: { range: string; rate: string }[] = [];

    data: any[] = [];
    cities: any[] = [];
    provinces: any[] = [];

    companyTermsAndCondition1: boolean = false;
    companyTermsAndCondition2: boolean = false;
    companyTermsAndCondition3: boolean = false;

    id_front_file: File | null = null;
    id_back_file: File | null = null;
    cf_front_file: File | null = null;
    cf_back_file: File | null = null;
    documentUploadStates: Partial<Record<RegisterCompanyDocumentField, boolean>> = {};
    documentUploadErrors: Partial<Record<RegisterCompanyDocumentField, string>> = {};


    OTPCode: string = '';

    canResendOtp = false;
    isResendingOtp = false;
    otpResendSecondsLeft = 0;

    disableButton: boolean = true;

    showPassword: boolean = false;

    isProcessing: boolean = false;

    private registrationSubmitting = false;
    private otpVerified = false;

    private readonly STEP_STORAGE_KEY = 'register-company-step';
    private readonly OTP_STEP = 7;
    private readonly PAYMENT_STEP = 8;
    private readonly DATA_STORAGE_KEY = 'register-company-data';
    private readonly PASSWORD_STORAGE_KEY = 'register-company-password';
    private readonly ONBOARDING_TOKEN_STORAGE_KEY = 'register-company-onboarding-token';
    private readonly OTP_RESEND_DELAY_SECONDS = 20;
    private otpResendInterval: ReturnType<typeof setInterval> | null = null;
    private representativeSaveTimeout: ReturnType<typeof setTimeout> | null = null;
    private contactsSaveTimeout: ReturnType<typeof setTimeout> | null = null;
    private companyInfoSaveTimeout: ReturnType<typeof setTimeout> | null = null;
    private servicesSaveTimeout: ReturnType<typeof setTimeout> | null = null;
    private termsSaveTimeout: ReturnType<typeof setTimeout> | null = null;
    private pendingOnboardingServices: CompanyServicesOnboardingData | null = null;

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        public userService: UserService,
        public categoryService: CategoryService,
        public serviceService: ServiceService,
        public companyService: CompanyService,
        public onboardingService: OnboardingService,
        public router: Router,
        public route: ActivatedRoute) {
    }

    async ngOnInit(): Promise<void> {
        this.restoreFormData();

        const savedStep = localStorage.getItem(this.STEP_STORAGE_KEY);
        if (savedStep !== null) {
            const parsedStep = Number(savedStep);
            const hasServerOnboarding = !!localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
            this.stepNumber = parsedStep > 1 && !hasServerOnboarding ? 1 : parsedStep;
            this.stepEmit.emit(this.stepNumber);
        }

        const restoredFromServer = await this.restoreOnboardingFromServer(true);
        if (!restoredFromServer && this.stepNumber >= this.PAYMENT_STEP) {
            this.stepNumber = this.OTP_STEP;
            localStorage.setItem(this.STEP_STORAGE_KEY, String(this.OTP_STEP));
        }
        if (this.stepNumber >= this.PAYMENT_STEP) {
            this.otpVerified = true;
        }

        this.updateSidebar();
        this.listOfStepsEmitter.emit([]);

        const idService = this.idService ?? this.route.snapshot.queryParamMap.get('idService') ?? this.route.snapshot.queryParamMap.get('idservice');
        if (idService) {
            let service = await this.serviceService.getServiceById(idService);
            if (!service) {
                const all = await this.serviceService.getAllServices(true);
                service = all.find((s: Service) => String(s.id) === String(idService)) ?? null;
            }
            if (service) {
                this.services = [service];
                this.servicesSelected = [service];
                this.newCompany.service = service;
                this.restoreServiceSelection();
            } else {
                this.services = [];
            }
        } else {
            this.serviceService.getAllServices().then((services: Service[]) => {
                this.services = services;
                this.servicesSelected = this.services.filter((service: Service) => service.required === 1);

                // Ripristina la selezione dei servizi salvati
                this.restoreServiceSelection();
            });
        }
        this.tariffTiers = [...TRANSACTION_TARIFF_TIERS];
        fetch('../../../assets/italia_comuni.json')
            .then((jsonData: any) => jsonData.json())
            .then((res: any) => {
                this.data = res.regioni;
                this.data.forEach((region: any) => {
                    region.province.forEach((province: any) => this.provinces.push({
                        id: province.code,
                        name: province.nome
                    }))
                })
                this.provinces.sort((a: any, b: any) => a.name > b.name ? 1 : -1)

                // Ripristina le città dopo il caricamento dei dati
                if (this.newCompany.legalProvince) {
                    this.updateCitiesLegal();
                }
                if (this.newCompany.province) {
                    this.updateCitiesCompany();
                }
            })
            .catch((error: any) => console.error('error fetching locationData: ', error))

        if (this.stepNumber === this.OTP_STEP) {
            this.startOtpResendTimer();
        }
    }

    ngOnDestroy(): void {
        this.clearOtpResendTimer();
        if (this.representativeSaveTimeout) {
            clearTimeout(this.representativeSaveTimeout);
        }
        if (this.contactsSaveTimeout) {
            clearTimeout(this.contactsSaveTimeout);
        }
        if (this.companyInfoSaveTimeout) {
            clearTimeout(this.companyInfoSaveTimeout);
        }
        if (this.servicesSaveTimeout) {
            clearTimeout(this.servicesSaveTimeout);
        }
        if (this.termsSaveTimeout) {
            clearTimeout(this.termsSaveTimeout);
        }
    }

    async saveBeforeExit(): Promise<void> {
        if (this.representativeSaveTimeout) {
            clearTimeout(this.representativeSaveTimeout);
            this.representativeSaveTimeout = null;
        }

        if (this.stepNumber === 2) {
            await this.persistRepresentativeOnboarding();
        }
        if (this.contactsSaveTimeout) {
            clearTimeout(this.contactsSaveTimeout);
            this.contactsSaveTimeout = null;
        }
        if (this.stepNumber === 3) {
            await this.persistContactsOnboarding();
        }
        if (this.companyInfoSaveTimeout) {
            clearTimeout(this.companyInfoSaveTimeout);
            this.companyInfoSaveTimeout = null;
        }
        if (this.stepNumber === 4) {
            await this.persistCompanyInfoOnboarding();
        }
        if (this.servicesSaveTimeout) {
            clearTimeout(this.servicesSaveTimeout);
            this.servicesSaveTimeout = null;
        }
        if (this.stepNumber === 5) {
            await this.persistServicesOnboarding();
        }
        if (this.termsSaveTimeout) {
            clearTimeout(this.termsSaveTimeout);
            this.termsSaveTimeout = null;
        }
        if (this.stepNumber === 6) {
            await this.persistTermsOnboarding();
        }
        await this.persistOnboardingStep();
    }

    get hasEnteredOtp(): boolean {
        return (this.OTPCode?.trim().length ?? 0) >= 6;
    }

    get showResendOtpButton(): boolean {
        return this.stepNumber === 7 && this.canResendOtp && !this.hasEnteredOtp;
    }

    get showOtpResendCountdown(): boolean {
        return this.stepNumber === 7 && !this.canResendOtp && !this.hasEnteredOtp && this.otpResendSecondsLeft > 0;
    }

    updateSidebar() {
        if (this.stepNumber < 1) {
            this.listOfStepsEmitter.emit([]);
        } else {
            this.listOfStepsEmitter.emit(this.stepsCompany);
        }
    }

    isPasswordValid(): boolean {
        if (!this.newCompany.legalPassword) return false;
        const hasUpper = /[A-Z]/.test(this.newCompany.legalPassword);
        const hasLower = /[a-z]/.test(this.newCompany.legalPassword);
        const hasNumber = /[0-9]/.test(this.newCompany.legalPassword);
        const hasSpecial = /[\W_]/.test(this.newCompany.legalPassword);
        const hasMinLength = this.newCompany.legalPassword.length >= 8;
        return hasUpper && hasLower && hasNumber && hasSpecial && hasMinLength;
    }

    async chooseDocument(event: Event, field: RegisterCompanyDocumentField): Promise<void> {
        const target = event.target as any;
        if (target.files && target.files.length > 0) {
            (this as any)[field] = target.files[0];
            await this.uploadRepresentativeDocument(target.files[0], field);
        }
    }

    async onDocumentDrop(event: DragEvent, field: RegisterCompanyDocumentField): Promise<void> {
        event.preventDefault();
        const file = event.dataTransfer?.files?.[0];
        if (!file) return;
        (this as any)[field] = file;
        await this.uploadRepresentativeDocument(file, field);
    }

    async uploadDocument(file: File) {
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        const response = await this.userService.uploadUser(formData);
        if (response?.success) return response.data;
        return null;
    }

    private async uploadRepresentativeDocument(file: File, field: RegisterCompanyDocumentField): Promise<void> {
        this.documentUploadStates = {...this.documentUploadStates, [field]: true};
        delete this.documentUploadErrors[field];

        try {
            const uploadedUrl = await this.uploadDocument(file);
            if (!uploadedUrl) {
                this.documentUploadErrors = {
                    ...this.documentUploadErrors,
                    [field]: 'Non è stato possibile caricare il documento. Riprova.'
                };
                return;
            }

            this.setRepresentativeDocumentUrl(field, uploadedUrl as string);
            this.saveFormData();
            await this.persistRepresentativeOnboarding();
        } catch (error) {
            console.error('Unable to upload representative document:', error);
            this.documentUploadErrors = {
                ...this.documentUploadErrors,
                [field]: 'Non è stato possibile caricare il documento. Riprova.'
            };
        } finally {
            this.documentUploadStates = {...this.documentUploadStates, [field]: false};
        }
    }

    async nextStep(skipProcessingGuard = false) {
        if (!skipProcessingGuard && (!this.stepCheck() || this.isProcessing || this.registrationSubmitting)) return;

        this.isProcessing = true;
        try {
            if (this.stepNumber === 0) {
                this.setStep(1);
                return;
            }

            if (this.stepNumber === 1) {
                const email = this.newCompany.legalEmail?.trim();
                const password = this.newCompany.legalPassword;
                if (!email || !password || !this.isPasswordValid()) return;

                const response = await this.onboardingService.startCompanyManager(email, password);
                if (!response?.success || !response.data?.resumeToken) {
                    await this.showOnboardingStartError(response);
                    return;
                }

                localStorage.setItem(this.ONBOARDING_TOKEN_STORAGE_KEY, response.data.resumeToken);
                const nextStep = response.data.created
                    ? 2
                    : Math.max(2, Number(response.data.currentStep) || 2);
                if (!response.data.created) {
                    await this.restoreOnboardingFromServer(true);
                }
                this.setStep(nextStep);
                return;
            }

            if (this.stepNumber === 2) {
                if (this.hasPendingDocumentUploads
                    || !this.hasAllUploadedRepresentativeDocuments
                    || !this.newCompany.legalFirstName
                    || !this.newCompany.legalLastName
                    || !this.newCompany.legalFiscalCode
                    || !this.newCompany.legalDocumentNumber) {
                    return;
                }
                const representativeSaved = await this.persistRepresentativeOnboarding();
                if (!representativeSaved.success) {
                    await this.showOnboardingApiError(
                        representativeSaved,
                        'Non è stato possibile salvare i dati del rappresentante. Riprova tra qualche istante.'
                    );
                    return;
                }
            }

            if (this.stepNumber === 3) {
                if (this.contactsSaveTimeout) {
                    clearTimeout(this.contactsSaveTimeout);
                    this.contactsSaveTimeout = null;
                }
                const contactsSaved = await this.persistContactsOnboarding();
                if (!contactsSaved.success) {
                    await this.showOnboardingApiError(
                        contactsSaved,
                        'Non è stato possibile salvare indirizzo e contatti. Riprova tra qualche istante.'
                    );
                    return;
                }
            }

            if (this.stepNumber === 4) {
                if (!this.isCompanyInfoValid()) return;
                if (this.companyInfoSaveTimeout) {
                    clearTimeout(this.companyInfoSaveTimeout);
                    this.companyInfoSaveTimeout = null;
                }
                const companySaved = await this.persistCompanyInfoOnboarding();
                if (!companySaved.success) {
                    await this.showOnboardingApiError(
                        companySaved,
                        'Non è stato possibile salvare i dati della società. Riprova tra qualche istante.'
                    );
                    return;
                }
            }

            if (this.stepNumber === 5) {
                if (!this.servicesSelected.length) return;
                if (this.servicesSaveTimeout) {
                    clearTimeout(this.servicesSaveTimeout);
                    this.servicesSaveTimeout = null;
                }
                const servicesSaved = await this.persistServicesOnboarding();
                if (!servicesSaved.success) {
                    await this.showOnboardingApiError(
                        servicesSaved,
                        'Non è stato possibile salvare il piano selezionato. Riprova tra qualche istante.'
                    );
                    return;
                }
            }

            if (this.stepNumber === this.OTP_STEP) {
                if (!this.otpVerified) {
                    return;
                }
                this.setStep(this.PAYMENT_STEP);
                return;
            }

            // Normal navigation between steps
            if (this.stepNumber !== 6) {
                this.setStep(this.stepNumber + 1);
            } else {
                if (this.registrationSubmitting) {
                    return;
                }

                if (!(this.companyTermsAndCondition1
                    && this.companyTermsAndCondition2
                    && this.companyTermsAndCondition3)) {
                    return;
                }

                if (this.termsSaveTimeout) {
                    clearTimeout(this.termsSaveTimeout);
                    this.termsSaveTimeout = null;
                }
                const termsSaved = await this.persistTermsOnboarding();
                if (!termsSaved.success) {
                    await this.showOnboardingApiError(
                        termsSaved,
                        'Non è stato possibile salvare le accettazioni. Riprova tra qualche istante.'
                    );
                    return;
                }

                if (!this.newCompany.legalPassword || !this.isPasswordValid()) {
                    await this.promptMissingPassword();
                    return;
                }

                this.registrationSubmitting = true;

                let response = await this.companyService.register(this.newCompany, this.billingPeriod);

                if (response?.success) {
                    this.persistRegistrationAuth(response.data);
                    const nextStep = this.isRegistrationOtpVerified(response.data)
                        ? this.PAYMENT_STEP
                        : this.OTP_STEP;
                    this.setStep(nextStep);
                } else if (response?.code === 'USER_ALREADY_EXIST') {
                    const existingToken = localStorage.getItem(Constants.LOCAL_TOKEN);
                    if (existingToken) {
                        this.setStep(this.OTP_STEP);
                        return;
                    }
                    this.registrationSubmitting = false;
                    await this.showOnboardingApiError(
                        response,
                        'L\'utente inserito esiste già, impossibile proseguire.'
                    );
                } else {
                    this.registrationSubmitting = false;
                    await this.showRegistrationError(response);
                }
            }
        } finally {
            this.isProcessing = false;
        }
    }

    previousStep() {
        if (this.stepNumber === 0) return;
        this.saveFormData();
        this.setStep(this.stepNumber - 1);
    }

    stepCheck() {
        // sto creando un account per il genitore/tutore
        return true;
    }

    companyLegalIsValid() {
        return (
            this.newCompany.legalFirstName &&
            this.newCompany.legalLastName &&
            this.newCompany.legalAddress &&
            this.newCompany.legalAddressNumber &&
            this.newCompany.legalZip &&
            this.newCompany.legalProvince &&
            this.newCompany.legalCity &&
            this.newCompany.legalFiscalCode &&
            this.newCompany.legalDocumentNumber &&
            this.newCompany.legalEmail &&
            this.newCompany.legalPhone
        )
    }

    /** Step 4: company info form is valid (required fields + patterns). */
    isCompanyInfoValid(): boolean {
        const c = this.newCompany;
        const hasEmail = (value?: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
        if (!c?.name?.trim()
            || !c.companyEmail?.trim()
            || !c.iban?.trim()
            || !c.fiscalCode?.trim()
            || !c.vat?.trim()
            || !c.address?.trim()
            || !String(c.addressNumber ?? '').trim()
            || !c.zip?.trim()
            || !c.province?.trim()
            || !c.city?.trim()) {
            return false;
        }
        const fc = (c.fiscalCode || '').replace(/\s+/g, '').toUpperCase();
        if (!/^[A-Z0-9]{11}$/.test(fc)) return false;
        const v = (c.vat || '').replace(/\D/g, '');
        if (!/^\d{11}$/.test(v)) return false;
        const iban = (c.iban || '').replace(/\s+/g, '').toUpperCase();
        if (!/^IT[0-9A-Z]{25}$/.test(iban)) return false;
        if (!/^\d{5}$/.test(c.zip)) return false;
        const sdi = (c.sdi || '').replace(/\s+/g, '').toUpperCase();
        if (sdi && !/^[A-Z0-9]{7}$/.test(sdi)) return false;
        if (!hasEmail(c.companyEmail)) return false;
        if ((c.pec || '').trim() && !hasEmail(c.pec)) return false;
        return true;
    }

    /** Step 3 button: enabled when form is valid or our explicit check passes (fallback). */
    canProceedStep3(form?: NgForm | null): boolean {
        if (form && form.valid) return true;
        return this.isCompanyInfoValid();
    }

    /**
     * Called when the Stripe embedded checkout completes successfully.
     * Shows a friendly confirmation screen before redirecting the user.
     */
    onPaymentCompleted() {
        // Move to the final confirmation step (UI only)
        this.setStep(9);
    }

    backToLogin() {
        this.router.navigate(['/login'])
    }

    async checkOTP(otp: string, email: string) {
        if (this.isProcessing) return;
        this.isProcessing = true;
        try {
            const response = await this.companyService.checkOTP(otp, email);
            if (response.success) {
                this.otpVerified = true;
                this.clearOtpResendTimer();
                await this.nextStep(true);
            } else {
                await this.showOnboardingApiError(
                    response ?? {code: 'OTP_NOT_VALID'},
                    'Non è stato possibile verificare il codice OTP inserito.'
                );
            }
        } finally {
            this.isProcessing = false;
        }
    }

    async resendOtp() {
        const email = this.newCompany.legalEmail?.trim();
        if (!email || this.isResendingOtp || !this.canResendOtp || this.hasEnteredOtp) {
            return;
        }

        this.isResendingOtp = true;
        try {
            const response = await this.userService.resendOTP(email);
            const sent = response && response.success !== false && !response.code;

            if (sent) {
                this.OTPCode = '';
                this.canResendOtp = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Nuovo codice inviato',
                    text: 'Controlla la tua casella email.'
                });
                this.startOtpResendTimer();
            } else {
                await this.showOnboardingApiError(
                    response ?? {code: 'USER_NOT_FOUND'},
                    'Impossibile inviare un nuovo codice. Riprova tra qualche istante.'
                );
            }
        } finally {
            this.isResendingOtp = false;
        }
    }

    /*  sendRegistrationCompany(){
        this.companyService.register(this.newCompany);
        this.nextStep();
      }*/

    generateServiceDescription(service: Service) {
        if (service.priceType === 'monthly') {
            return `(${parseInt(service.price)}€ / mese + 2,44% tasse incluse)`
        } else {
            return `(${parseInt(service.price)}€ una tantum ( tasse incluse) )`
        }
    }

    getDisplayedMonthlyPrice(service: Service): number {
        const base = parseFloat(service.price || '0');
        if (this.billingPeriod === 'monthly') {
            return base;
        }
        // Total billed amount for the selected recurrence plan (e.g. 6/12/24 months)
        return parseFloat(service.annualPrice || '0');
    }

    getAnnualBilledMonthlyPrice(service: Service): number {
        const annual = parseFloat(service.annualPrice || '0');
        const recurrencyMonths = this.getServiceRecurrencyMonths(service);
        return Number.isNaN(annual) ? 0 : annual / recurrencyMonths;
    }

    getServiceRecurrencyMonths(service: Service): number {
        const raw = Number((service as any)?.recurrency);
        return Number.isFinite(raw) && raw > 0 ? raw : 12;
    }

    /** Plan uses negotiated commission and/or fixed duration instead of default tier table. */
    hasCustomSubscriptionTerms(service: Service): boolean {
        return service.customFeeRate != null || service.monthCount != null;
    }

    /** Hide progressive transaction fee table when the chosen plan defines custom terms. */
    shouldHideStandardTariffTable(): boolean {
        const s = this.newCompany.service;
        return !!s && this.hasCustomSubscriptionTerms(s);
    }

    private parsePrice(raw: string | undefined | null): number {
        const n = parseFloat(String(raw ?? '').replace(/\s/g, '').replace(',', '.'));
        return Number.isNaN(n) ? NaN : n;
    }

    /**
     * Percent saved vs paying 12× monthly: (monthly×12 − annual) / (monthly×12) × 100.
     * Null if annual is missing or there is no positive discount.
     */
    getAnnualSavingsPercent(service: Service): number | null {
        const monthly = this.parsePrice(service.price);
        const annual = this.parsePrice(service.annualPrice);
        if (Number.isNaN(monthly) || Number.isNaN(annual) || monthly <= 0) {
            return null;
        }
        const fullYearAtMonthly = monthly * this.getServiceRecurrencyMonths(service);
        if (fullYearAtMonthly <= 0) {
            return null;
        }
        const pct = ((fullYearAtMonthly - annual) / fullYearAtMonthly) * 100;
        if (pct <= 0.05) {
            return null;
        }
        return Math.round(pct * 10) / 10;
    }

    /** Euro discount per year: monthly×12 − annual (null if not meaningful). */
    getAnnualSavingsEuro(service: Service): number | null {
        const monthly = this.parsePrice(service.price);
        const annual = this.parsePrice(service.annualPrice);
        if (Number.isNaN(monthly) || Number.isNaN(annual) || monthly <= 0) {
            return null;
        }
        const diff = monthly * this.getServiceRecurrencyMonths(service) - annual;
        if (diff <= 0.01) {
            return null;
        }
        return Math.round(diff * 100) / 100;
    }

    /** Annual list price as number for display (0 if missing/invalid). */
    getAnnualTotalForDisplay(service: Service): number {
        const n = this.parsePrice(service.annualPrice);
        return Number.isNaN(n) ? 0 : n;
    }

    /** Monthly list price for display (0 if invalid). */
    getMonthlyListPrice(service: Service): number {
        const m = this.parsePrice(service.price);
        return Number.isNaN(m) ? 0 : m;
    }

    /** 12× monthly list price — reference “full” year cost before annual discount. */
    getFullYearAtMonthlyListPrice(service: Service): number {
        const m = this.parsePrice(service.price);
        const recurrencyMonths = this.getServiceRecurrencyMonths(service);
        return Number.isNaN(m) ? 0 : Math.round(m * recurrencyMonths * 100) / 100;
    }

    selectPlan(service: Service) {
        // keep required services, switch the chosen plan
        const requiredServices = this.servicesSelected.filter((s: Service) => s.required === 1);
        const alreadySelected = this.setCheckbox(service);

        this.servicesSelected = [...requiredServices];
        if (!alreadySelected) {
            this.servicesSelected.push(service);
        }

        this.newCompany.service = service;
        this.newCompany.billedPeriod = this.billingPeriod;
        this.persistForm();
    }

    selectService(service: Service) {
        if (this.servicesSelected.find((elem: Service) => service.id === elem.id)) {
            this.servicesSelected = [...this.servicesSelected.filter((item: Service) => service.id !== item.id)];
        } else {
            this.servicesSelected.push(service)
        }

        this.newCompany.service = service;
    }

    setCheckbox(serviceCheckbox: Service) {
        return this.servicesSelected.find((service: Service) => serviceCheckbox.id === service.id)
    }

    /** Display a feature whether it's a string or an object (e.g. { name, code }) from the API */
    getFeatureLabel(feature: string | { name?: string; code?: string } | unknown): string {
        if (feature == null) return '';
        if (typeof feature === 'string') return feature;
        const o = feature as { name?: string; code?: string };
        return o?.name ?? o?.code ?? String(feature);
    }

    updateStep($event: any) {
        this.setStep($event);
    }

    onCompanySubmit(form: NgForm) {
        // mark all controls as touched to show validation messages
        if (form && form.controls) {
            Object.keys(form.controls).forEach(key => {
                const control = (form.controls as any)[key];
                if (control && control.markAsTouched) control.markAsTouched();
                if (control && control.markAsDirty) control.markAsDirty();
            });
        }

        if (this.isCompanyInfoValid()) {
            console.log("Company info valid, proceeding to next step");
            this.nextStep();
        }
    }

    // Normalization helpers called from template
    normalizeFiscalCode() {
        if (this.newCompany && typeof this.newCompany.fiscalCode === 'string') {
            this.newCompany.fiscalCode = this.newCompany.fiscalCode.replace(/\s+/g, '').toUpperCase();
        }
    }

    normalizeVat() {
        if (this.newCompany && typeof this.newCompany.vat === 'string') {
            this.newCompany.vat = this.newCompany.vat.replace(/\D/g, '');
        }
    }

    normalizeCompanyEmail() {
        if (this.newCompany && typeof this.newCompany.companyEmail === 'string') {
            this.newCompany.companyEmail = this.newCompany.companyEmail.trim();
        }
    }

    normalizeIban() {
        if (this.newCompany && typeof this.newCompany.iban === 'string') {
            this.newCompany.iban = this.newCompany.iban.replace(/\s+/g, '').toUpperCase();
        }
    }

    updateCitiesLegal() {
        this.cities = [];
        let province: any[] = [];

        this.data.forEach((region: any) => {
            if (region.province.find((province: any) => province.code === this.newCompany.legalProvince)) {
                province = region.province.find((province: any) => province.code === this.newCompany.legalProvince).comuni
            }
        });

        this.cities = province.map((city: any) => city.nome);

        this.cities.sort();
    }

    updateCitiesCompany() {
        this.cities = [];
        let province: any[] = [];

        this.data.forEach((region: any) => {
            if (region.province.find((province: any) => province.code === this.newCompany.province)) {
                province = region.province.find((province: any) => province.code === this.newCompany.province).comuni
            }
        });

        this.cities = province.map((city: any) => city.nome);

        this.cities.sort();
    }

    private setStep(step: number) {
        if (this.stepNumber === 7 && step !== 7) {
            this.clearOtpResendTimer();
            this.canResendOtp = false;
            this.otpResendSecondsLeft = 0;
        }

        if (step !== 6) {
            this.registrationSubmitting = false;
        }

        this.stepNumber = step;
        localStorage.setItem(
            this.STEP_STORAGE_KEY,
            this.stepNumber.toString()
        );
        this.saveFormData();
        this.stepEmit.emit(this.stepNumber);
        this.updateSidebar();
        void this.persistOnboardingStep();
        if (this.stepNumber >= 9) {
            localStorage.removeItem(this.STEP_STORAGE_KEY);
            localStorage.removeItem(this.DATA_STORAGE_KEY);
            localStorage.removeItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
            sessionStorage.removeItem(this.PASSWORD_STORAGE_KEY);
        }

        if (this.stepNumber === this.OTP_STEP) {
            this.startOtpResendTimer();
        }
    }

    private isRegistrationOtpVerified(data?: { otpRequired?: boolean; user?: { status?: string } }): boolean {
        return data?.otpRequired === false;
    }

    private persistRegistrationAuth(data?: {
        accessToken?: string;
        refreshToken?: string;
        userId?: string;
    }): void {
        if (!data) {
            return;
        }
        if (data.accessToken) {
            localStorage.setItem(Constants.LOCAL_TOKEN, data.accessToken);
        }
        if (data.refreshToken) {
            localStorage.setItem('wisper_refreshToken', data.refreshToken);
        }
        if (data.userId) {
            localStorage.setItem('wisper_userId', data.userId);
        }
    }

    private startOtpResendTimer() {
        this.clearOtpResendTimer();
        this.canResendOtp = false;
        this.otpResendSecondsLeft = this.OTP_RESEND_DELAY_SECONDS;

        this.otpResendInterval = setInterval(() => {
            this.otpResendSecondsLeft -= 1;

            if (this.otpResendSecondsLeft <= 0) {
                this.clearOtpResendTimer();
                if (!this.hasEnteredOtp) {
                    this.canResendOtp = true;
                }
            }
        }, 1000);
    }

    private clearOtpResendTimer() {
        if (this.otpResendInterval) {
            clearInterval(this.otpResendInterval);
            this.otpResendInterval = null;
        }
    }

    private saveFormData(): void {
        const data: any = {
            newCompany: { ...this.newCompany },
            billingPeriod: this.billingPeriod,
            servicesSelectedIds: this.servicesSelected.map(s => s.id),
            companyTermsAndCondition1: this.companyTermsAndCondition1,
            companyTermsAndCondition2: this.companyTermsAndCondition2,
            companyTermsAndCondition3: this.companyTermsAndCondition3,
        };
        if (this.newCompany.legalPassword) {
            sessionStorage.setItem(this.PASSWORD_STORAGE_KEY, this.newCompany.legalPassword);
        }
        delete data.newCompany.legalPassword;
        // Non salvare oggetti Service complessi — salviamo solo l'ID
        if (this.newCompany.service) {
            data.selectedServiceId = this.newCompany.service.id;
        }
        delete data.newCompany.service;
        localStorage.setItem(this.DATA_STORAGE_KEY, JSON.stringify(data));
    }

    private restoreFormData(): void {
        const raw = localStorage.getItem(this.DATA_STORAGE_KEY);
        if (!raw) return;
        try {
            const data = JSON.parse(raw);
            if (data.newCompany) {
                Object.assign(this.newCompany, data.newCompany);
            }
            const savedPassword = sessionStorage.getItem(this.PASSWORD_STORAGE_KEY);
            if (savedPassword) {
                this.newCompany.legalPassword = savedPassword;
            }
            if (data.billingPeriod) {
                this.billingPeriod = data.billingPeriod;
            }
            if (data.companyTermsAndCondition1 !== undefined) {
                this.companyTermsAndCondition1 = data.companyTermsAndCondition1;
            }
            if (data.companyTermsAndCondition2 !== undefined) {
                this.companyTermsAndCondition2 = data.companyTermsAndCondition2;
            }
            if (data.companyTermsAndCondition3 !== undefined) {
                this.companyTermsAndCondition3 = data.companyTermsAndCondition3;
            }
            // I servizi vengono ripristinati dopo il caricamento in restoreServiceSelection()
        } catch (e) {
            console.error('Error restoring company registration form data:', e);
        }
    }

    private restoreServiceSelection(): void {
        const raw = localStorage.getItem(this.DATA_STORAGE_KEY);
        if (raw) {
            try {
                const data = JSON.parse(raw);
                if (data.servicesSelectedIds && this.services.length > 0) {
                    const savedIds = data.servicesSelectedIds as string[];
                    const restored = this.services.filter(s => savedIds.includes(s.id));
                    if (restored.length > 0) {
                        this.servicesSelected = restored;
                    }
                }
                if (data.selectedServiceId && this.services.length > 0) {
                    const found = this.services.find(s => String(s.id) === String(data.selectedServiceId));
                    if (found) {
                        this.newCompany.service = found;
                    }
                }
            } catch (e) {
                console.error('Error restoring service selection:', e);
            }
        }
        this.applyPendingOnboardingServices();
    }

    private applyPendingOnboardingServices(): void {
        const data = this.pendingOnboardingServices;
        if (!data || !this.services.length) return;

        if (data.billingPeriod === 'monthly' || data.billingPeriod === 'yearly') {
            this.billingPeriod = data.billingPeriod;
            this.newCompany.billedPeriod = data.billingPeriod;
        }

        const ids = data.serviceIds?.length
            ? data.serviceIds
            : (data.serviceId ? [data.serviceId] : []);
        if (ids.length) {
            const restored = this.services.filter(s => ids.some(id => String(id) === String(s.id)));
            if (restored.length > 0) {
                this.servicesSelected = restored;
            }
        }
        if (data.serviceId) {
            const found = this.services.find(s => String(s.id) === String(data.serviceId));
            if (found) {
                this.newCompany.service = found;
            }
        }
    }

    persistForm(): void {
        this.saveFormData();
        if (this.stepNumber === 2) {
            this.scheduleRepresentativePersistence();
        }
        if (this.stepNumber === 3) {
            this.scheduleContactsPersistence();
        }
        if (this.stepNumber === 4) {
            this.scheduleCompanyInfoPersistence();
        }
        if (this.stepNumber === 5) {
            this.scheduleServicesPersistence();
        }
        if (this.stepNumber === 6) {
            this.scheduleTermsPersistence();
        }
    }

    get hasPendingDocumentUploads(): boolean {
        return Object.values(this.documentUploadStates).some(Boolean);
    }

    get hasAllUploadedRepresentativeDocuments(): boolean {
        return !!(
            this.newCompany.legalDocumentFront
            && this.newCompany.legalDocumentBack
            && this.newCompany.legalFiscalCodeFront
            && this.newCompany.legalFiscalCodeBack
        );
    }

    private setRepresentativeDocumentUrl(field: RegisterCompanyDocumentField, url: string): void {
        const companyField: Record<RegisterCompanyDocumentField, keyof Company> = {
            id_front_file: 'legalDocumentFront',
            id_back_file: 'legalDocumentBack',
            cf_front_file: 'legalFiscalCodeFront',
            cf_back_file: 'legalFiscalCodeBack',
        };
        (this.newCompany as any)[companyField[field]] = url;
    }

    private getRepresentativeData(): CompanyRepresentativeOnboardingData {
        return {
            legalFirstName: this.newCompany.legalFirstName,
            legalLastName: this.newCompany.legalLastName,
            legalFiscalCode: this.newCompany.legalFiscalCode,
            legalDocumentNumber: this.newCompany.legalDocumentNumber,
            legalDocumentFront: this.newCompany.legalDocumentFront,
            legalDocumentBack: this.newCompany.legalDocumentBack,
            legalFiscalCodeFront: this.newCompany.legalFiscalCodeFront,
            legalFiscalCodeBack: this.newCompany.legalFiscalCodeBack,
        };
    }

    private scheduleRepresentativePersistence(): void {
        if (this.representativeSaveTimeout) {
            clearTimeout(this.representativeSaveTimeout);
        }
        this.representativeSaveTimeout = setTimeout(() => {
            void this.persistRepresentativeOnboarding();
        }, 350);
    }

    private async persistRepresentativeOnboarding(): Promise<OnboardingApiResult> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        return await this.onboardingService.saveRepresentative(resumeToken ?? '', this.getRepresentativeData());
    }

    private getContactsData(): CompanyContactsOnboardingData {
        const rawPhone = this.newCompany.legalPhone?.trim() ?? '';
        const legalPhone = rawPhone && !rawPhone.startsWith('+')
            ? `+39${rawPhone.replace(/\D/g, '')}`
            : rawPhone.replace(/(?!^)\D/g, '');
        if (legalPhone) {
            this.newCompany.legalPhone = legalPhone;
        }

        return {
            legalAddress: this.newCompany.legalAddress,
            legalAddressNumber: this.newCompany.legalAddressNumber,
            legalZip: this.newCompany.legalZip,
            legalProvince: this.newCompany.legalProvince,
            legalCity: this.newCompany.legalCity,
            legalPhone,
        };
    }

    private scheduleContactsPersistence(): void {
        if (this.contactsSaveTimeout) {
            clearTimeout(this.contactsSaveTimeout);
        }
        this.contactsSaveTimeout = setTimeout(() => {
            this.contactsSaveTimeout = null;
            void this.persistContactsOnboarding();
        }, 350);
    }

    private async persistContactsOnboarding(): Promise<OnboardingApiResult> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        return await this.onboardingService.saveContacts(resumeToken ?? '', this.getContactsData());
    }

    private getCompanyInfoData(): CompanyInfoOnboardingData {
        const iban = (this.newCompany.iban ?? '').replace(/\s+/g, '').toUpperCase();
        const fiscalCode = (this.newCompany.fiscalCode ?? '').replace(/\s+/g, '').toUpperCase();
        const vat = String(this.newCompany.vat ?? '').replace(/\D/g, '');
        const sdi = (this.newCompany.sdi ?? '').replace(/\s+/g, '').toUpperCase();
        if (iban) this.newCompany.iban = iban;
        if (fiscalCode) this.newCompany.fiscalCode = fiscalCode;
        if (vat) this.newCompany.vat = vat;
        if (sdi) this.newCompany.sdi = sdi;

        return {
            name: this.newCompany.name?.trim(),
            fiscalCode,
            vat,
            sdi,
            pec: this.newCompany.pec?.trim(),
            address: this.newCompany.address?.trim(),
            addressNumber: String(this.newCompany.addressNumber ?? '').trim() || undefined,
            zip: this.newCompany.zip?.trim(),
            province: this.newCompany.province,
            city: this.newCompany.city,
            companyEmail: this.newCompany.companyEmail?.trim(),
            iban,
        };
    }

    private scheduleCompanyInfoPersistence(): void {
        if (this.companyInfoSaveTimeout) {
            clearTimeout(this.companyInfoSaveTimeout);
        }
        this.companyInfoSaveTimeout = setTimeout(() => {
            this.companyInfoSaveTimeout = null;
            void this.persistCompanyInfoOnboarding();
        }, 350);
    }

    private async persistCompanyInfoOnboarding(): Promise<OnboardingApiResult> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        return await this.onboardingService.saveCompanyInfo(resumeToken ?? '', this.getCompanyInfoData());
    }

    private getServicesData(): CompanyServicesOnboardingData {
        this.newCompany.billedPeriod = this.billingPeriod;
        return {
            serviceId: this.newCompany.service?.id,
            billingPeriod: this.billingPeriod,
            serviceIds: this.servicesSelected.map(service => service.id).filter(Boolean),
        };
    }

    private scheduleServicesPersistence(): void {
        if (this.servicesSaveTimeout) {
            clearTimeout(this.servicesSaveTimeout);
        }
        this.servicesSaveTimeout = setTimeout(() => {
            this.servicesSaveTimeout = null;
            void this.persistServicesOnboarding();
        }, 350);
    }

    private async persistServicesOnboarding(): Promise<OnboardingApiResult> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        return await this.onboardingService.saveServices(resumeToken ?? '', this.getServicesData());
    }

    private getTermsData(): CompanyTermsOnboardingData {
        return {
            termsAccepted: this.companyTermsAndCondition1,
            privacyAccepted: this.companyTermsAndCondition2,
            clausesAccepted: this.companyTermsAndCondition3,
        };
    }

    private scheduleTermsPersistence(): void {
        if (this.termsSaveTimeout) {
            clearTimeout(this.termsSaveTimeout);
        }
        this.termsSaveTimeout = setTimeout(() => {
            this.termsSaveTimeout = null;
            void this.persistTermsOnboarding();
        }, 350);
    }

    private async persistTermsOnboarding(): Promise<OnboardingApiResult> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        return await this.onboardingService.saveTerms(resumeToken ?? '', this.getTermsData());
    }

    private async restoreOnboardingFromServer(overwriteExisting = false): Promise<boolean> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        if (!resumeToken) return false;

        const response = await this.onboardingService.getOnboarding(resumeToken);
        if (!response?.success || !response.data) return false;

        const serverStep = Number(response.data.currentStep);
        if (Number.isInteger(serverStep) && serverStep >= 1 && serverStep <= this.stepsCompany.length) {
            this.stepNumber = serverStep;
            localStorage.setItem(this.STEP_STORAGE_KEY, String(serverStep));
            this.stepEmit.emit(serverStep);
            if (serverStep >= this.PAYMENT_STEP) {
                this.otpVerified = true;
            }
        }
        const representative = response?.data?.data?.representative;
        const contacts = response?.data?.data?.contacts;
        const companyInfo = response?.data?.data?.companyInfo;
        const services = response?.data?.data?.services;
        const terms = response?.data?.data?.terms;

        [representative, contacts, companyInfo].filter(Boolean).forEach(section => {
            Object.entries(section!).forEach(([key, value]) => {
                if (value !== undefined
                    && value !== null
                    && value !== ''
                    && (overwriteExisting || !(this.newCompany as any)[key])) {
                    (this.newCompany as any)[key] = value;
                }
            });
        });

        if (services) {
            this.pendingOnboardingServices = services;
            if (services.billingPeriod === 'monthly' || services.billingPeriod === 'yearly') {
                this.billingPeriod = services.billingPeriod;
                this.newCompany.billedPeriod = services.billingPeriod;
            }
            this.applyPendingOnboardingServices();
        }

        if (terms) {
            this.companyTermsAndCondition1 = terms.termsAccepted === true;
            this.companyTermsAndCondition2 = terms.privacyAccepted === true;
            this.companyTermsAndCondition3 = terms.clausesAccepted === true;
        }

        this.saveFormData();
        return true;
    }

    private async promptMissingPassword(): Promise<void> {
        const result = await Swal.fire({
            icon: 'warning',
            title: 'Password mancante',
            text: 'Per completare la registrazione devi reinserire la password nel passo "Account manager".',
            confirmButtonText: 'Vai all\'account manager',
            showCancelButton: true,
            cancelButtonText: 'Annulla',
        });

        if (result.isConfirmed) {
            this.setStep(1);
        }
    }

    private async persistOnboardingStep(): Promise<void> {
        const resumeToken = localStorage.getItem(this.ONBOARDING_TOKEN_STORAGE_KEY);
        if (!resumeToken || this.stepNumber < 1) {
            return;
        }
        const stepToSave = (this.otpVerified || this.stepNumber < this.PAYMENT_STEP)
            ? this.stepNumber
            : this.OTP_STEP;
        await this.onboardingService.saveStep(resumeToken, stepToSave);
    }

    private async showOnboardingApiError(response: any, fallbackText?: string): Promise<void> {
        const copy = getOnboardingErrorCopy(response, fallbackText);
        await Swal.fire({
            icon: 'error',
            title: copy.title,
            text: copy.text,
        });
    }

    private async showOnboardingStartError(response: any): Promise<void> {
        await this.showOnboardingApiError(
            response,
            'Controlla i dati inseriti e riprova tra qualche istante.'
        );
    }

    private async showRegistrationError(response: any): Promise<void> {
        const payload = response?.error ?? response;
        const details = payload?.details ?? payload?.error?.details;
        const codes: string[] = details?.codes ?? [];
        const messages: Array<Record<string, string>> = details?.messages ?? [];

        if (codes.includes('PASSWORD_REQUIRED')
            || payload?.code === 'PASSWORD_REQUIRED'
            || !this.newCompany.legalPassword) {
            await this.promptMissingPassword();
            return;
        }

        const validationMessages = messages
            .flatMap((entry) => Object.values(entry))
            .filter((message): message is string => !!message);

        if (validationMessages.length) {
            const copy = getOnboardingErrorCopy(payload, validationMessages.join('\n'));
            await Swal.fire({
                icon: 'error',
                title: copy.title,
                text: validationMessages.join('\n'),
            });
            return;
        }

        await this.showOnboardingApiError(
            payload,
            'Si è verificato un errore durante la registrazione. Controlla i dati inseriti e riprova.'
        );
    }
}
